import { useMemo } from 'react';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { InstantInput } from '@repo/ui';

import { selectParkStartAtTimestamp, useParkingSearchStore } from '@shared/stores/useParkingSearchStore';

interface Props {
  testId: TestId;
}

export default function ParkStartInput({ testId }: Props) {
  const startAtTimestamp = useParkingSearchStore(selectParkStartAtTimestamp);
  const parkStart = useMemo(
    () => (startAtTimestamp !== undefined ? new Date(startAtTimestamp) : undefined),
    [startAtTimestamp]
  );
  const setParkStart = useParkingSearchStore((state) => state.setParkStart);

  const handleClear = () => setParkStart(undefined);

  return (
    <InstantInput
      mode="datetime"
      value={parkStart}
      onChange={setParkStart}
      clearable
      onClear={handleClear}
      disablePast
      placeholder={tr('parking_search:desktop_bar.park_start_placeholder')}
      size="sm"
      className="bg-primary-soft border-stroke-base-medium text-heading flex w-42 cursor-pointer items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm font-medium"
      testId={testId}
    />
  );
}
